var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if(selectedDate.getDate() === 22 && selectedMonth === 4 && selectedDate.getFullYear() === 2026) {  	
    timepicker.set('min',[11, 0]); 
    timepicker.set('max',[15, 0]);
  }
  if(selectedDate.getDate() === 26 && selectedMonth === 10 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[11, 0]); 
    timepicker.set('max',[14, 0]);
  }
  
  if(selectedDate.getDate() === 24 && selectedMonth === 11 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[13, 0]);
  }

  if(selectedDate.getDate() === 31 && selectedMonth === 11 && selectedDate.getFullYear() === 2025) {  	
    timepicker.set('min',[11, 0]); 
    timepicker.set('max',[14, 0]);
  }
}